import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'desktop/store';

import {PrimerStateType} from '../../reducers/primer/primer';
import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Get primer state
 * @param {ApplicationStoreType} store - Current store
 * @returns {PrimerStateType} - primer state
 */
export const getPrimerState = (store: ApplicationStoreType): PrimerStateType =>
    store[MODULE_KEY_CHECKOUT].primer;

/**
 * Get is save card checked in primer method
 * @returns {boolean} - is save card checked
 */
export const getIsSaveCardChecked = createSelector(
    getPrimerState,
    primerState => primerState.isSaveCardChecked,
);

/**
 * Get primer selected previous card vault id
 * @returns {string} - vault payment id
 */
export const getVaultPaymentId = createSelector(
    getPrimerState,
    primerState => primerState.vaultPaymentId,
);

/**
 * Get primer vaulted payment methods
 * @returns {VaultedPaymentMethod[]} - vaulted payment methods
 */
export const getVaultedPaymentMethods = createSelector(
    getPrimerState,
    primerState => primerState.vaultedPaymentMethods,
);

/**
 * State of the primer credit card payment, when customer clicks on pay button it becomes true
 * @returns {boolean} - is credit card submit loading
 */
export const getIsPrimerCreditCardLoading = createSelector(
    getPrimerState,
    primerState => primerState.isCreditCardLoading,
);
